// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"logo__pageTitle__3JYEc","focusable":"logo__focusable__o3jbH","logoWrapper":"logo__logoWrapper__28a_t"};